import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ck",
  "use": "icon-ck-usage",
  "viewBox": "0 0 13 10.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 10.6\" id=\"icon-ck\"><title>资源 3</title><g id=\"icon-ck_图层_2\" data-name=\"图层 2\"><g id=\"icon-ck_图层_1-2\" data-name=\"图层 1\"><path d=\"M6.5,10.6A6.8,6.8,0,0,1,0,5.5H0V5A6.7,6.7,0,0,1,6.5,0,6.7,6.7,0,0,1,13,5h0v.4A6.8,6.8,0,0,1,6.5,10.6ZM1,5.4a5.7,5.7,0,0,0,11,0V5.2a5.7,5.7,0,0,0-11,0Z\" /><path d=\"M6.5,8A2.7,2.7,0,0,1,3.8,5.3,2.8,2.8,0,0,1,6.5,2.5,2.8,2.8,0,0,1,9.2,5.3,2.7,2.7,0,0,1,6.5,8Zm0-4.5A1.7,1.7,0,0,0,4.8,5.3a1.7,1.7,0,0,0,3.4,0A1.7,1.7,0,0,0,6.5,3.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ck.svg
// module id = UH9m
// module chunks = 72